module.exports = __webpack_public_path__ + "13-autumn-snow.749f441314c93140f473.png";


//////////////////
// WEBPACK FOOTER
// D:/projects/4164_AppsPotr_Backend/production/CMS_prod/src/assets/images/festival/13-autumn-snow.png
// module id = ../../../../../src/assets/images/festival/13-autumn-snow.png
// module chunks = styles